module.exports = __webpack_public_path__ + "img/鎏金面膜_04.4b4b84d2.jpg";